import { render, staticRenderFns } from "./chunked-ebooks-display.vue?vue&type=template&id=1aa1b20a&"
import script from "./chunked-ebooks-display.vue?vue&type=script&lang=js&"
export * from "./chunked-ebooks-display.vue?vue&type=script&lang=js&"
import style0 from "./chunked-ebooks-display.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports